import { axiosClient as apiClient } from './axiosClient';

// API service functions
const apiService = {
  // Authentication
  login: (credentials, userType = '') => {
    const endpoint = userType ? `/auth/login/${userType}/` : '/auth/login/';
    return apiClient.post(endpoint, credentials);
  },
  
  register: (userData, userType = '') => {
    const endpoint = userType ? `/auth/register/${userType}/` : '/auth/register/';
    return apiClient.post(endpoint, userData);
  },
  
  addClient: (clientData) => {
    return apiClient.post('/auth/addclient/', clientData);
  },
  
  logout: () => {
    return apiClient.post('/auth/logout/');
  },
  
  refreshToken: (refreshToken) => {
    return apiClient.post('/auth/token/refresh/', { refresh: refreshToken });
  },
  
  getUserProfile: () => {
    return apiClient.get('/auth/profile/');
  },
  
  updateUserProfile: (userData) => {
    return apiClient.put('/auth/profile/', userData);
  },
  
  changePassword: (passwordData) => {
    return apiClient.post('/auth/change-password/', passwordData);
  },
  
  // Password Reset
  requestPasswordReset: (email) => {
    return apiClient.post('/auth/password-reset/', { email });
  },
  
  resetPassword: (token, passwordData) => {
    return apiClient.post(`/auth/reset-password/${token}/`, passwordData);
  },
};

export default apiService;
